import React, { useEffect } from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import { Report } from 'types/report';
import CandidateStoryForm from './Body/CandidateStoryForm/Container';
import { CandidateStoryFailure, CandidateStorySuccess } from './Body';
import {
  hideChat,
  showChat,
} from '../../../../CandidateLandingPage/chatVisibility';

type Props = {
  companyName: string;
  isOpen: boolean;
  toggleCandidateStoryModal: () => void;
  report: Report;
  candidateStorySubmitted: boolean;
  generalInformationOnly: boolean;
  submitError: boolean;
  toggleDisputeModal: () => void;
};

const CandidateStoryModal = ({
  companyName,
  isOpen = false,
  toggleCandidateStoryModal = () => {},
  report,
  candidateStorySubmitted = false,
  generalInformationOnly = false,
  submitError,
  toggleDisputeModal = () => {},
}: Props) => {
  useEffect(() => {
    if (isOpen) {
      hideChat();
    } else {
      showChat();
    }
  }, [isOpen]);

  return (
    <M.ComposedModal data-testid='candidate-story-modal' open={isOpen}>
      <M.ModalHeader
        data-testid='candidate-story-modal-title'
        buttonOnClick={toggleCandidateStoryModal}
      >
        <T
          value='components.Report.CandidateStories.Modal.title'
          company={companyName}
        />
      </M.ModalHeader>
      <M.ModalBody data-testid='candidate-story-modal-body'>
        {candidateStorySubmitted && !submitError && (
          <CandidateStorySuccess
            company={companyName}
            formName='CandidateStory'
          />
        )}
        {candidateStorySubmitted && submitError && <CandidateStoryFailure />}
        {!candidateStorySubmitted && (
          <CandidateStoryForm
            companyName={companyName}
            report={report}
            toggleCandidateStoryModal={toggleCandidateStoryModal}
            toggleDisputeModal={toggleDisputeModal}
            generalInformationOnly={generalInformationOnly}
          />
        )}
      </M.ModalBody>
    </M.ComposedModal>
  );
};

export default CandidateStoryModal;
